import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

const RoomManagerForm = forwardRef(function ({ onSubmit, groups }, ref) {
  const [formData, setFormData] = useState({
    roomName: '',
    groupId: '',
    groupName: '',
  });
  const [selectedGroup, setSelectedGroup] = useState({});

  useImperativeHandle(ref, () => ({
    resetForm: () => {
      setFormData({
        roomName: '',
      });
    },
    setForm: (data) => {
      setFormData(data);
    },
  }));

  const handleChange = (prop) => (event) => {
    setFormData({ ...formData, [prop]: event.target.value });
  };
  const handleEditGroup = (group) => {
    setSelectedGroup(group);
    setFormData({
      ...formData,
      groupId: group.id,
      groupName: group.groupName,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box>
        <TextField
          label="Room Name"
          type="text"
          value={formData.roomName}
          onChange={handleChange('roomName')}
          inputProps={{ minLength: 3 }}
          margin="normal"
          fullWidth
          required
        />
      </Box>
      {
        // selecte Group from dropdown
        groups.length > 0 && (
          <Box
            sx={{
              width: {
                sm: '100%', // for medium screens and up
                md: '100%', // for large screens and up
              },
            }}
          >
            <FormControl fullWidth margin="normal">
              <InputLabel id="groupLabel">Select Group</InputLabel>
              <Select
                value={selectedGroup}
                onChange={(e) => handleEditGroup(e.target.value)}
                labelId="groupLabel"
                label="Select Group"
                placeholder="Select Group"
              >
                {groups.map((group) => (
                  <MenuItem key={group.id} value={group}>
                    {group.groupName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )
      }
      <Button type="submit" variant="contained" color="primary">
        Add
      </Button>
      <Button
        style={{ marginLeft: 10 }}
        variant="contained"
        color="error"
        onClick={() => {
          setFormData({
            roomName: '',
          });
        }}
      >
        Clear
      </Button>
    </form>
  );
});

RoomManagerForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  groups: PropTypes.array.isRequired,
};

RoomManagerForm.displayName = 'RoomManagerForm';
export default RoomManagerForm;
